// libraries
import React, { useState } from 'react'
import { Select, MenuItem, Checkbox, ListItemText, FormControl, InputLabel } from '@mui/material'

export const useSelectFilter = ({ localStorageKey, options, defaultOptions, label = 'Status' }) => {
  const [allowedOptions, setAllowedOptions] = useState(
    (JSON.parse(window.localStorage.getItem(localStorageKey)) || defaultOptions).sort((a, b) => {
      if (a < b) return -1
      if (b < a) return 1
      return 0
    }),
  )
  const isAllSelected = options.length > 0 && allowedOptions.length === options.length

  const handleChange = event => {
    const { value } = event.target
    let newOptions = value
    if (value[value.length - 1] === 'ALL') {
      newOptions = isAllSelected ? [] : options.map(option => option.id)
    }
    setAllowedOptions(
      newOptions.sort((a, b) => {
        if (a < b) return -1
        if (b < a) return 1
        return 0
      }),
    )
    window.localStorage.setItem(localStorageKey, JSON.stringify(newOptions))
  }

  return {
    allowedOptions,
    renderSelectFilter: () => (
      <FormControl data-testid="select-filter">
        <InputLabel id="select-filter-label" shrink>
          {label}
        </InputLabel>
        <Select
          multiple
          label={label}
          labelId="select-filter-label"
          value={allowedOptions}
          onChange={handleChange}
          renderValue={selected =>
            selected.length === 1
              ? options.find(option => option.id === selected[0])?.name
              : `${selected.length} Selected`
          }
          displayEmpty
        >
          <MenuItem value="ALL">
            <Checkbox
              checked={isAllSelected}
              indeterminate={allowedOptions.length > 0 && allowedOptions.length < options.length}
            />
            <ListItemText primary="Select All" />
          </MenuItem>
          {options.map(option => (
            <MenuItem key={option?.id} value={option?.id}>
              <Checkbox checked={allowedOptions.indexOf(option?.id) > -1} />
              <ListItemText primary={option?.name} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    ),
  }
}
